// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles-module__cardContainer___1IB9Q"};